import { render, staticRenderFns } from "./VorderDialog.vue?vue&type=template&id=244027c6&scoped=true&"
import script from "./VorderDialog.vue?vue&type=script&lang=js&"
export * from "./VorderDialog.vue?vue&type=script&lang=js&"
import style0 from "./VorderDialog.vue?vue&type=style&index=0&id=244027c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244027c6",
  null
  
)

export default component.exports